// import React, { useState, useEffect } from 'react';
// import { db } from '../OurCourses/firebase'; 
// import { collection, query, where, getDocs } from 'firebase/firestore';
// import './verification.css';

// const Verification = () => {
//   const [nicNo, setNicNo] = useState('');
//   const [studentData, setStudentData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [recentVerifications, setRecentVerifications] = useState([]);

//   const verifyCertificate = async (e) => {
//     e.preventDefault();
//     if (!nicNo.trim()) {
//       setError('Please enter a NIC No');
//       return;
//     }

//     setLoading(true);
//     setError('');
    
//     try {
//       const q = query(
//         collection(db, 'verificationCertificates'),
//         where('nicNo', '==', nicNo)
//       );
      
//       const querySnapshot = await getDocs(q);
      
//       if (querySnapshot.empty) {
//         setError('Certificate not found');
//         setStudentData(null);
//       } else {
//         const docData = querySnapshot.docs[0].data();
//         setStudentData(docData);
//         setError('');
        
//         // Add to recent verifications
//         setRecentVerifications(prev => [
//           { id: nicNo, name: docData.studentName, date: new Date() },
//           ...prev.slice(0, 4)
//         ]);
//       }
//     } catch (err) {
//       console.error('Verification error:', err);
//       setError('Error verifying certificate');
//       setStudentData(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetForm = () => {
//     setNicNo('');
//     setStudentData(null);
//     setError('');
//   };






//   return (
// <div className="cert-verify-app">
//   <div className="cert-verify-header">
//     <h1 className="cert-verify-title">Student Certificate Verification</h1>
//     <p className="cert-verify-subtitle">Verify the authenticity of academic certificates</p>
//   </div>
  
//   <div className="cert-verify-main">
//     <div className="cert-verify-form-container">
//       <div className="cert-verify-form-box">
//         <h2 className="cert-verify-form-title">Verify Certificate</h2>
//         <p className="cert-verify-form-desc">Enter the Student's NIC No to verify its authenticity</p>

//         <form onSubmit={verifyCertificate} className="cert-verify-form">
//           <div className="cert-input-group">
//             <label htmlFor="nicNo" className="cert-input-label">Student's NIC No</label>
//             <input
//               type="text"
//               id="nicNo"
//               className="cert-input-field"
//               value={nicNo}
//               onChange={(e) => setNicNo(e.target.value)}
//               onFocus={() => {
//                 if (error) {
//                   resetForm();
//                 }
//               }}
//               placeholder="Enter Student's NIC No"
//               required
//             />
//           </div>
          
//          <div className="cert-button-group" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//   <button 
//     type="submit" 
//     className="cert-verify-btn"
//     disabled={loading}
//   >
//     {loading ? (
//       <>
//         <span className="cert-verify-spinner"></span>
//         Verifying...
//       </>
//     ) : 'Verify Certificate'}
//   </button>
//   <button 
//     type="button" 
//     className="cert-clear-btn"
//     onClick={resetForm}
//     style={{ marginLeft: 'auto' }}
//   >
//     Reset
//   </button>
// </div>


//         </form>
        
//         {error && (
//           <div className="cert-result-box cert-result-invalid">
//             <div className="cert-result-icon">
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
//                 <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
//               </svg>
//             </div>
//             <h3 className="cert-result-title">Verification Failed</h3>
//             <p className="cert-result-text">{error}</p>
//           </div>
//         )}
//       </div>
      
//       {studentData && (
//         <div className="cert-verify-form-box">
//           <div className="cert-result-box cert-result-valid">
//             <div className="cert-result-icon">
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
//                 <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
//               </svg>
//             </div>
//             <h3 className="cert-result-title">Certificate Verified</h3>
//             <p className="cert-result-text">This certificate has been successfully verified.</p>
            
//             <div className="cert-details-box">
//               <p><span>Student Name:</span> {studentData.studentName}</p>
//               <p><span>NIC No:</span> {studentData.nicNo}</p>
//               <p><span>Course:</span> {studentData.course}</p>
//               <p><span>Certificate Issue Date:</span> {new Date(studentData.issueDate.seconds * 1000).toLocaleDateString()}</p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
    
//     {recentVerifications.length > 0 && (
//       <div className="cert-recent-checks">
//         <h3 className="cert-recent-title">Recent Verifications</h3>
//         <ul className="cert-recent-list">
//           {recentVerifications.map((item, index) => (
//             <li key={index} className="cert-recent-item">
//               <span className="cert-recent-badge">Verified</span>
//               <span className="cert-recent-id">{item.id}</span>
//               <span className="cert-recent-name">{item.name}</span>
//               <span className="cert-recent-time">
//                 {item.date.toLocaleTimeString()}
//               </span>
//             </li>
//           ))}
//         </ul>
//       </div>
//     )}
//   </div>
  
//   <div className="cert-verify-footer">
//     <p className="cert-footer-text">Need help? <a href="/contactus" className="cert-footer-link">Contact support</a></p>
//   </div>
// </div>
//   );
// }

// export default Verification;




import React, { useState } from 'react';
import { db } from '../OurCourses/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import './verification.css';

const Verification = () => {
  const [nicNo, setNicNo] = useState('');
  const [studentCertificates, setStudentCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [recentVerifications, setRecentVerifications] = useState([]);

  const verifyCertificate = async (e) => {
    e.preventDefault();
    if (!nicNo.trim()) {
      setError('Please enter a NIC No');
      return;
    }

    setLoading(true);
    setError('');
    setStudentCertificates([]);

    try {
      const upperNic = nicNo.toUpperCase();
      const q = query(
        collection(db, 'verificationCertificates'),
        where('nicNo', '==', upperNic)
      );

      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError('Certificate not found');
      } else {
        const dataList = querySnapshot.docs.map(doc => doc.data());
        setStudentCertificates(dataList);
        setError('');

        const first = dataList[0];
        setRecentVerifications(prev => [
          { id: upperNic, name: first.studentName, date: new Date() },
          ...prev.slice(0, 4)
        ]);
      }
    } catch (err) {
      console.error('Verification error:', err);
      setError('Error verifying certificate');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setNicNo('');
    setStudentCertificates([]);
    setError('');
  };

  return (
    <div className="cert-verify-app">
      <div className="cert-verify-header">
        <h1 className="cert-verify-title">Student Certificate Verification</h1>
        <p className="cert-verify-subtitle">Verify the authenticity of academic certificates</p>
      </div>

      <div className="cert-verify-main">
        <div className="cert-verify-form-container">
          <div className="cert-verify-form-box">
            <h2 className="cert-verify-form-title">Verify Certificate</h2>
            <p className="cert-verify-form-desc">Enter the Student's NIC No to verify its authenticity</p>

            <form onSubmit={verifyCertificate} className="cert-verify-form">
              <div className="cert-input-group">
                <label htmlFor="nicNo" className="cert-input-label">Student's NIC No</label>
                <input
                  type="text"
                  id="nicNo"
                  className="cert-input-field"
                  value={nicNo}
                  onChange={(e) => setNicNo(e.target.value.toUpperCase())}
                  onFocus={() => {
                    if (error) {
                      resetForm();
                    }
                  }}
                  placeholder="Enter Student's NIC No"
                  required
                />
              </div>

              <div className="cert-button-group" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <button
                  type="submit"
                  className="cert-verify-btn"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="cert-verify-spinner"></span>
                      Verifying...
                    </>
                  ) : 'Verify Certificate'}
                </button>
                <button
                  type="button"
                  className="cert-clear-btn"
                  onClick={resetForm}
                  style={{ marginLeft: 'auto' }}
                >
                  Reset
                </button>
              </div>
            </form>

            {error && (
              <div className="cert-result-box cert-result-invalid">
                <div className="cert-result-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                  </svg>
                </div>
                <h3 className="cert-result-title">Verification Failed</h3>
                <p className="cert-result-text">{error}</p>
              </div>
            )}
          </div>

          {studentCertificates.length > 0 && (
            <div className="cert-verify-form-box">
              <h3 className="cert-result-title">{studentCertificates.length} Certificate(s) Found</h3>

              {studentCertificates.map((data, index) => (
                <div key={index} className="cert-result-box cert-result-valid" style={{ marginBottom: '1rem' }}>
                  <div className="cert-result-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </div>
                  <h3 className="cert-result-title">Certificate Verified</h3>
                  <p className="cert-result-text">This certificate has been successfully verified.</p>

                  <div className="cert-details-box">
                    <p><span>Student Name:</span> {data.studentName}</p>
                    <p><span>NIC No:</span> {data.nicNo}</p>
                    <p><span>Course:</span> {data.course}</p>
                    <p><span>Certificate Issue Date:</span> {new Date(data.issueDate.seconds * 1000).toLocaleDateString()}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {recentVerifications.length > 0 && (
          <div className="cert-recent-checks">
            <h3 className="cert-recent-title">Recent Verifications</h3>
            <ul className="cert-recent-list">
              {recentVerifications.map((item, index) => (
                <li key={index} className="cert-recent-item">
                  <span className="cert-recent-badge">Verified</span>
                  <span className="cert-recent-id">{item.id}</span>
                  <span className="cert-recent-name">{item.name}</span>
                  <span className="cert-recent-time">{item.date.toLocaleTimeString()}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className="cert-verify-footer">
        <p className="cert-footer-text">Need help? <a href="/contactus" className="cert-footer-link">Contact support</a></p>
      </div>
    </div>
  );
};

export default Verification;
